import { COLORS_JSON } from '@eventbrite/legacy-eds.styles/color';

export const ACTION_CREATE_ATTEMPT = 'CreateAttempt';
export const ACTION_DISCOVER = 'Discover';
export const ACTION_HELP_ARTICLE = 'HelpArticle';
export const ACTION_HELP_LINK_CLICK = 'HelpLinkClicked';
export const ACTION_HELP_LINK_HOVER = 'HelpLinkHovered';
export const ACTION_HOST_AN_EVENT_CLICK = 'HostAnEventLinkClicked';
export const ACTION_HOST_AN_EVENT_HOVER = 'HostAnEventLinkHovered';
export const ACTION_FIND_AN_EVENT_CLICK = 'FindAnEventLinkClicked';
export const ACTION_FIND_AN_EVENT_HOVER = 'FindAnEventLinkHovered';
export const ACTION_ORGANIZE_AN_EVENT_CLICK = 'OrganizeAnEventLinkClicked';
export const ACTION_ORGANIZE_AN_EVENT_HOVER = 'OrganizeAnEventLinkHovered';
export const ACTION_SIGNIN_CLICK = 'SignInClicked';
export const ACTION_LOGIN_HOVER = 'SignInHovered';
export const ACTION_LOGIN_ATTEMPT = 'LoginAttempt';
export const ACTION_SIGNUP_CLICK = 'SignUpClicked';
export const ACTION_LOGO_HOME = 'LogoHome';
export const ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const ACTION_LOGOUT = 'Logout';
export const CATEGORY_HEADER = 'header';
export const LABEL_HELP_CENTER = 'HelpCenter';
export const LABEL_ACCOUNT = 'Account';
export const LABEL_CREATE_EVENT = 'CreateEvent';
export const LABEL_FIND_EVENT = 'FindEvent';
export const LABEL_ORGANIZE_EVENT = 'OrganizeEvent';
export const LABEL_MY_CONTACTS = 'My Contacts';
export const LABEL_MY_EVENTS = 'ManageMyEvents (consumer)';
export const LABEL_ORGANIZER_PROFILE = 'My Organizer Profile';
export const LABEL_SAVED = 'Saved';
export const LABEL_TICKETS = 'Tickets';
export const LABEL_FOLLOWING = 'Following';
export const LABEL_COLLECTIONS = 'Collections';
export const LABEL_INTERESTS = 'Interests';
export const LABEL_SPONSORSHIPS = 'Sponsorships';
export const LABEL_STUDIO = 'Studio';
export const LABEL_CREDITS = 'Credits';
export const LABEL_EMAIL_NAME_ACCOUNT = 'EmailAndNameAccount';

export const GA_SEARCH_AUTOCOMPLETE_SUGGESTION_ACTION = 'AutocompleteSuggestionClicked';
export const ORGANIZER_NAVBAR = 'organizer';
export const ATTENDEE_NAVBAR = 'attendee';

export const MENU_AVATAR_BACKGROUND = 'control';
export const MENU_AVATAR_COLOR = 'white';
export const ORGANIZATIONS_URL = '/organizations';
export const MANAGE_URL = '/manage';

// #3D64FF is the hex value for $ui-blue, the standard blue used for links at EB
export const UI_BLUE = COLORS_JSON['ui-blue'];
